<app-rich-text
    class="block h-fit"
    [data]="blockNodes().slice(0, 3)"
></app-rich-text>
@if (blockNodes().length > 3) {
    <app-button
        size="small"
        aria-haspopup="dialog"
        aria-expanded="false"
        [attr.aria-controls]="'hs-basic-modal-' + index()"
        [attr.data-hs-overlay]="'#hs-basic-modal-' + index()"
        [id]="'hs-basic-modal-' + index() + '-trigger'"
    >
        {{ "blog.readMore" | translate }}
    </app-button>

    <div
        [id]="'hs-basic-modal-' + index()"
        class="hidden top-0 z-50 fixed opacity-0 hs-overlay-open:opacity-100 size-full overflow-x-hidden overflow-y-auto transition-all hs-overlay-open:duration-500 pointer-events-none hs-overlay start-0"
        role="dialog"
        tabindex="-1"
        aria-labelledby="hs-basic-modal-label"
    >
        <div class="m-3 sm:mx-auto sm:w-full sm:max-w-lg h-[calc(100%-56px)]">
            <div
                class="flex flex-col bg-black shadow-2xs border border-gray-700 rounded-xl h-fit pointer-events-auto"
            >
                <div class="p-4 max-h-[calc(100vh-160px)] overflow-y-auto">
                    <app-rich-text [data]="blockNodes()"></app-rich-text>
                </div>

                <div
                    class="flex justify-end items-center gap-x-2 mb-2 px-4 py-3 border-gray-700 border-t"
                >
                    <app-button
                        size="small"
                        [attr.data-hs-overlay]="'#hs-basic-modal-' + index()"
                    >
                        {{ "blog.close" | translate }}
                    </app-button>
                </div>
            </div>
        </div>
    </div>
}
